import axios from 'axios';
import { EMAIL } from './types';

axios.defaults.headers.common['x-auth'] =
  localStorage.getItem('x-auth') || null;

if (localStorage.getItem('cart-id')) {
  axios.defaults.headers.common['cart-id'] = localStorage.getItem('cart-id');
}

// export const fetchUser = () => async dispatch => {
//   const res = await axios.get('/api/user/me');

//   dispatch({
//     type: FETCH_USER,
//     payload: res.data
//   });
// };

export const sendEmail = values => async dispatch => {
  const res = await axios.post('/api/send-email', { values });

  dispatch({
    type: EMAIL,
    payload: res.data
  });
};



// WEBPACK FOOTER //
// ./src/actions/index.js